<template>
  <v-list>
    <v-list-item class="mark-seen">
      <v-list-item-content class="py-0">
        <v-row>
          <v-col class="py-2">
            <checkbox
              class="font12 px-0 py-0"
              theme="light"
              id="progress-status"
              @click="loadNotifications"
              v-model="showProgress"
              title="Show Progress Only"
              :data-test-id="`${dataTestId}__show-progress-checkbox`"
            />
          </v-col>
          <v-col align="right" class="py-2">
            <v-btn
              small
              text
              tile
              underline
              class="px-0 caption"
              :disabled="!unreadNotificationCount"
              @click="markAsSeen"
              :data-test-id="`${dataTestId}__mark-all-seen-checkbox`"
              >Mark all as seen</v-btn
            >
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-row>
        <v-col class="pt-0">
          <Span class="caption">Filter By:</Span>
          <v-btn-toggle
            v-model="duration"
            mandatory
            borderless
            tile
            link
            text
            color="#58e2c2"
            @change="loadNotifications"
            class="caption"
          >
            <v-btn
              v-for="btn in itemsData"
              :key="btn.val"
              :value="btn.val"
              tile
              small
              text
              depressed
              class="main-menu global-btn"
              :data-test-id="`${dataTestId}__filter-day- ${btn.val}`"
              >{{ btn.label }}</v-btn
            >
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Checkbox from '../Common/Checkbox.vue';
export default {
  components: { Checkbox },
  data() {
    return {
      duration: 28,
      // filter that will show only progress of active
      // sync's. user can select Show Progress Only check
      showProgress: false,
      primaryColor: '#58e2c2',
      itemsData: [
        {
          val: 0,
          label: 'Today'
        },
        {
          val: 1,
          label: 'Yesterday'
        },
        {
          val: 7,
          label: '7 days'
        },
        {
          val: 28,
          label: '28 days'
        }
      ],
      dataTestId:'notification-panel'
    };
  },
  computed: {
    ...mapState({
      unreadNotificationCount: state => state.notifications.unreadCount ?? 0
    })
  },
  methods: {
    ...mapActions('notifications', ['markNotifsAsSeen']),
    loadNotifications() {
      this.$emit('filterSelected', parseInt(this.duration, 10), {
        showProgressOnly: this.showProgress
      });
    },
    markAsSeen() {
      this.markNotifsAsSeen();
    }
  }
};
</script>
<style scoped>
.mark-seen {
  min-height: 0;
}

.mark-seen button {
  border-bottom: 1px solid #58e2c2;
  height: 20px !important;
}
</style>
